export default "__VITE_ASSET__BRxQbJID__"